import React from 'react';
import { AppLauncherEngine } from '../../components/workspace/AppLauncherEngine';
import { GrowthToolsRegistry } from './GrowthToolsRegistry';

export function GrowthDashboard() {
  return (
    <AppLauncherEngine 
      hubId="growth" 
      hubName="Growth & Marketing" 
      tools={GrowthToolsRegistry} 
    />
  );
}
